import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19l16 0","key":"svg-0"}],["path",{"d":"M4 15l4 -6l4 2l4 -5l4 4l0 5l-16 0","key":"svg-1"}]]

const IconChartArea = createReactComponent('outline', 'chart-area', 'ChartArea', __iconNode);

export default IconChartArea;